import { defineStore } from "pinia";

export const useSelectedTransferRequestStore = defineStore("selectedTransferRequest", {
  state: () => ({
    selectedTransferRequestId: null as string | null,
    commentsOpen: false,
  }),
  actions: {
    openTransferRequestDrawer(transferRequestId: string, { comments = false } = {}) {
      this.selectedTransferRequestId = transferRequestId;
      this.commentsOpen = comments;
    },
    closeTransferRequestDrawer() {
      this.selectedTransferRequestId = null;
      this.commentsOpen = false;
    },
  },
});
